//空闲教室
import Classroom from "@/components/student/Classroom/classroom";
import classroom_refer from "@/components/student/Classroom/classroom_refer";
//成绩管理
import Score from "@/components/student/Score/score";
import semester_Score from "@/components/student/Score/semester_Score";
import semester_Score_10294 from "@/components/student/Score/semester_Score_10294";
import score_Affirmation from "@/components/student/Score/score_Affirmation";
import score_apply from "@/components/student/Score/score_apply";
import score_replace from "@/components/student/Score/score_replace";
import submit_success from "@/components/student/Score/submit_success";
import score_confirm from "@/components/student/Score/score_confirm";
import grades_score from "@/components/student/Score/grades_score";
//学籍
import SchoolRoll from "@/components/student/statusManage/schoolRoll";
import Warning from "@/components/student/statusManage/warning";
import curWarn from "@/components/student/statusManage/curWarn";
import allWarn from "@/components/student/statusManage/allWarn";
import warnDetail from "@/components/student/statusManage/warnDetail";
import Change from "@/components/student/statusManage/change";
import changeDetail from "@/components/student/statusManage/changeDetail";
import xs_xjxxck from "@/components/student/statusManage/xs_xjxxck";
//考试安排
import Exam from "@/components/student/exam";
//补考查询
import SupplementExam from "@/components/student/supplementExam";
//缓考
import delayedExam from "@/components/student/delayTest/delayedExam";
import delayApply from "@/components/student/delayTest/delayApply";
import myApply from "@/components/student/delayTest/myApply";
import myApply1 from "@/components/student/delayTest/myApply1";
//等级考试
import gradeExam from "@/components/student/gradeExam";
import gradeDetail from "@/components/student/gradeDetail";
import myExam from "@/components/student/myExam";
//培养方案
import cultivate from "@/components/student/Cultivate/cultivate";
import syllabus from "@/components/student/Cultivate/syllabus";
import cultivateDetail from "@/components/student/Cultivate/cultivateDetail";
import courseSet from "@/components/student/Cultivate/courseSet";
import courseAdd from "@/components/student/Cultivate/courseAdd";
import courseDetails from "@/components/student/Cultivate/courseDetails";
import executePlan from "@/components/student/Cultivate/executePlan";
//选课
import pickClass from "@/components/student/pickClass/pickClass";
import creditStatistics from "@/components/student/pickClass/creditStatistics";
import pickCenter from "@/components/student/pickClass/pickCenter";
import exitPick from "@/components/student/pickClass/exitPick";
import pickDetail from "@/components/student/pickClass/pickDetail";
import pickRecord from "@/components/student/pickClass/pickRecord";
//评教
import evaluate from "@/components/student/Evaluate/evaluate";
import evaluate_10013 from "@/components/student/Evaluate/evaluate_10013";
import teachEvaluate from "@/components/student/Evaluate/teachEvaluate";
import teachEvaluateOnTime from "@/components/student/Evaluate/teachEvaluateOnTime";
import teachEvaluateGoal from "@/components/student/Evaluate/teachEvaluateGoal";
import evaluateRecod from "@/components/student/Evaluate/evaluateOnTimeHistory";

import teachEvaluate_10013 from "@/components/student/Evaluate/teachEvaluate_10013";
import teachEvaluate_10541 from "@/components/student/Evaluate/teachEvaluate_10541";
import teachEvaluate_10407 from "@/components/student/Evaluate/teachEvaluate_10407";
import detailEvaluateZtpj from "@/components/student/Evaluate/teachEvaluateZtpj";
import detailEvaluateSfpj from "@/components/student/Evaluate/teachEvaluateSfpj";

import teachEva from "@/components/student/Evaluate/teachEva";
import teachEva_10013 from "@/components/student/Evaluate/teachEva_10013";
import evaluateHistory from "@/components/student/Evaluate/evaluateHistory";
import detailEvaluate from "@/components/student/Evaluate/detailEvaluate";
import detailEvaluate_10013 from "@/components/student/Evaluate/detailEvaluate_10013";
import detailEvaluatefs from "@/components/student/Evaluate/detailEvaluatefs";
//辅导评教
import counsellingteachEvaluate from "@/components/student/counsellingEvaluate/teachEvaluate";
import counsellingteachEva from "@/components/student/counsellingEvaluate/teachEva";
import counsellingdetailEvaluatefd from "@/components/student/counsellingEvaluate/detailEvaluatefd";
import counsellingevaluateHistory from "@/components/student/counsellingEvaluate/evaluateHistory";
// 课程表
import timetable from "@/components/student/timetable";
//教材
import textbook from "@/components/student/Textbook/textbook";
import textbook_Details from "@/components/student/Textbook/textbook_Details";

import attendanceRate from "@/components/student/Attendance/attendanceRate";
import attendanceRate_qzzyjsdx from "@/components/student/Attendance/attendanceRate_qzzyjsdx";
import studentAttendance from "@/components/student/Attendance/attendance";
import studentAttendanceDtl from "@/components/student/Attendance/attendanceDetail";

//辅修报名
import MinorSearch from "@/components/student/minorSignUp/search";
import MinorList from "@/components/student/minorSignUp/list";

//重修报名
import RetouchList from "@/components/student/retouchSignUp/list";
import RetouchSubmit from "@/components/student/retouchSignUp/submit";
import RetouchChooseCureList from "@/components/student/retouchSignUp/retouchChooseCureList";
import RetouchCureDeal from "@/components/student/retouchSignUp/RetouchCureDeal";

//重修报名选课
import cxCuarChoose from "@/components/student/cxCuarChoose/cxCuarChooseIndex";
import cxCuarChooseList from "@/components/student/cxCuarChoose/cxCuarChooseList";
import cxCuarChooseHistory from "@/components/student/cxCuarChoose/cxCuarChooseHistory";

//报道注册
import RegistraTion from "@/components/student/RegistraTion/list";
import exemptExam from "@/components/student/exemptTest/exemptExam";
import exemptApply from "@/components/student/exemptTest/exemptApply";
import myExemptApply from "@/components/student/exemptTest/myExemptApply";
import myExemptApply1 from "@/components/student/exemptTest/myExemptApply1";
//毕业设计
import xs_design from "@/components/student/Design/design";
import to_guideRecode from "@/components/student/Design/to_guideRecode";
import myGuideDeal_unload from "@/components/student/Design/myGuideDeal_unload";
import MyguideDeal from "@/components/student/Design/MyGuideDeal";
import addQustMsg_unline from "@/components/student/Design/addQustMsg_unline";
import addQustMsg from "@/components/student/Design/addQustMsg";
//卓越计划
import zyjhDkxz from "@/components/student/zyjh/zyjhDkxz";
import zyjhDk from "@/components/student/zyjh/zyjhDk";
//教材订购
import xsxkjcDg from "@/components/student/jcdg/xsxkjcDg";
import xsxkjcDg_jcxz from "@/components/student/jcdg/xsxkjcDg_jcxz";
//实验课表
import SyKbTable from "@/components/newPages/Home/SyKbTable";
import SyKbTable_whkj from "@/components/newPages/Home/SyKbTable_whkj";
//体测成绩查看
import physicalExamination from "@/components/student/tccj/physicalExamination";
import physicalExamination_mx from "@/components/student/tccj/physicalExamination_mx";
import physicalExamination_cfmx from "@/components/student/tccj/physicalExamination_cfmx";
const studentRoute = [
  {
    path: "/student/classroom",
    name: "classroom",
    component: Classroom,
    meta: {
      title: "空闲教室查询"
    }
  },
  {
    path: "/student/classroom_refer",
    name: "classroom_refer",
    component: classroom_refer,
    meta: {
      title: "空闲教室查询"
    }
  },
  {
    path: "/student/score",
    name: "score",
    component: Score
  },
  {
    path: "/student/grades_score",
    name: "grades_score",
    component: grades_score
  },
  {
    path: "/student/semester_Score",
    name: "semester_Score",
    component: semester_Score
  },
  {
    path: "/student/semester_Score_10294",
    name: "semester_Score_10294",
    component: semester_Score_10294
  },
  {
    path: "/student/score_Affirmation",
    name: "score_Affirmation",
    component: score_Affirmation
  },
  {
    path: "/student/score_apply",
    name: "score_apply",
    component: score_apply
  },
  {
    path: "/student/score_replace",
    name: "score_replace",
    component: score_replace
  },
  {
    path: "/student/submit_success",
    name: "submit_success",
    component: submit_success
  },
  {
    path: "/student/score_confirm",
    name: "score_confirm",
    component: score_confirm
  },
  {
    path: "/student/schoolRoll",
    name: "schoolRoll",
    component: SchoolRoll
  },
  {
    path: "/student/warning",
    name: "warning",
    component: Warning,
    redirect: "/student/curWarn",
    children: [
      {
        path: "/student/curWarn",
        name: "curWarn",
        component: curWarn
      },
      {
        path: "/student/allWarn",
        name: "allWarn",
        component: allWarn
      }
    ]
  },
  {
    path: "/student/warnDetail",
    name: "warnDetail",
    component: warnDetail
  },
  {
    path: "/student/change",
    name: "change",
    component: Change
  },
  {
    path: "/student/changeDetail",
    name: "changeDetail",
    component: changeDetail
  },
  {
    path: "/student/exam",
    name: "exam",
    component: Exam
  },
  {
    path: "/student/delayedExam",
    name: "delayedExam",
    component: delayedExam
  },
  {
    path: "/student/exemptExam",
    name: "exemptExam",
    component: exemptExam
  },
  {
    path: "/student/exemptApply",
    name: "exemptApply",
    component: exemptApply
  },
  {
    path: "/student/myExemptApply",
    name: "myExemptApply",
    component: myExemptApply
  },
  {
    path: "/student/myExemptApply1",
    name: "myExemptApply1",
    component: myExemptApply1
  },
  {
    path: "/student/delayApply",
    name: "delayApply",
    component: delayApply
  },
  {
    path: "/student/myApply",
    name: "myApply",
    component: myApply
  },
  {
    path: "/student/myApply1",
    name: "myApply1",
    component: myApply1
  },
  {
    path: "/student/gradeExam",
    name: "gradeExam",
    component: gradeExam
  },
  {
    path: "/student/gradeDetail",
    name: "gradeDetail",
    component: gradeDetail
  },
  {
    path: "/student/myExam",
    name: "myExam",
    component: myExam
  },
  {
    path: "/student/cultivateDetail",
    name: "cultivateDetail",
    component: cultivateDetail,
    meta: {
      title: "培养方案明细"
    }
  },
  {
    path: "/student/courseSet",
    name: "courseSet",
    component: courseSet,
    meta: {
      title: "培养方案明细"
    }
  },
  {
    path: "/student/courseAdd",
    name: "courseAdd",
    component: courseAdd,
    meta: {
      title: "培养方案明细"
    }
  },
  {
    path: "/student/executePlan",
    name: "executePlan",
    component: executePlan
  },
  {
    path: "/student/courseDetails",
    name: "courseDetails",
    component: courseDetails
  },
  {
    path: "/student/cultivate",
    name: "cultivate",
    component: cultivate,
    meta: {
      title: "培养方案"
    }
  },
  {
    path: "/student/syllabus",
    name: "syllabus",
    component: syllabus
  },
  {
    path: "/student/evaluate",
    name: "evaluate",
    component: evaluate
  },
  {
    path: "/student/evaluate_10759",
    name: "evaluate",
    component: () => import('@/components/student/Evaluate/evaluate_10759/index.vue')
  },
  {
    path: "/student/evaluate_10759/set",
    name: "evaluate",
    component: () => import('@/components/student/Evaluate/evaluate_10759/set.vue')
  },
  {
    path: "/student/evaluate_10759/allLevelList",
    name: "evaluate",
    component: () => import('@/components/student/Evaluate/evaluate_10759/allLevelList.vue')
  },
  {
    path: "/student/evaluate_10759/evaluateList",
    name: "evaluate",
    component: () => import('@/components/student/Evaluate/evaluate_10759/evaluateList.vue')
  },
  {
    path: "/student/evaluate_10759/evaluate",
    name: "evaluate",
    component: () => import('@/components/student/Evaluate/evaluate_10759/evaluate.vue')
  },
  {
    path: "/student/evaluate_10013",
    name: "evaluate_10013",
    component: evaluate_10013
  },
  {
    path: "/student/evaluate",
    name: "evaluats",
    component: evaluate
  },
  {
    path: "/student/evaluate",
    name: "evaluatess",
    component: evaluate
  },
  {
    path: "/student/counsellingteachEvaluate",
    name: "counsellingteachEvaluate",
    component: counsellingteachEvaluate
  },
  {
    path: "/student/counsellingteachEva",
    name: "counsellingteachEva",
    component: counsellingteachEva
  },
  {
    path: "/student/counsellingdetailEvaluatefd",
    name: "counsellingdetailEvaluatefd",
    component: counsellingdetailEvaluatefd
  },
  {
    path: "/student/counsellingevaluateHistory",
    name: "counsellingevaluateHistory",
    component: counsellingevaluateHistory
  },
  {
    path: "/student/teachEvaluateOnTime",
    name: "teachEvaluateOnTime",
    component: teachEvaluateOnTime
  },
  {
    path: "/student/teachEvaluateGoal",
    name: "teachEvaluateGoal",
    component: teachEvaluateGoal
  },
  {
    path: "/student/findMyEvaluateRecod",
    name: "evaluateRecod",
    component: evaluateRecod
  },
  {
    path: "/student/teachEvaluate",
    name: "teachEvaluate",
    component: teachEvaluate
  }, //evaluateHistory
  {
    path: "/student/teachEvaluate_10013",
    name: "teachEvaluate_10013",
    component: teachEvaluate_10013
  },
  {
    path: "/student/teachEvaluate_10541",
    name: "teachEvaluate_10541",
    component: teachEvaluate_10541
  },
  {
    path: "/student/teachEvaluate_10407",
    name: "teachEvaluate_10407",
    component: teachEvaluate_10407
  },
  {
    path: "/student/detailEvaluateZtpj",
    name: "detailEvaluateZtpj",
    component: detailEvaluateZtpj
  },
  {
    path: "/student/detailEvaluateSfpj",
    name: "detailEvaluateSfpj",
    component: detailEvaluateSfpj
  },
  {
    path: "/student/teachEva",
    name: "teachEva",
    component: teachEva
  }, //evaluateHistory
  {
    path: "/student/teachEva_10013",
    name: "teachEva_10013",
    component: teachEva_10013
  },
  {
    path: "/student/evaluateHistory",
    name: "evaluateHistory",
    component: evaluateHistory
  },
  {
    path: "/student/detailEvaluate",
    name: "detailEvaluate",
    component: detailEvaluate
  },
  {
    path: "/student/detailEvaluate_10013",
    name: "detailEvaluate_10013",
    component: detailEvaluate_10013
  },
  {
    path: "/student/detailEvaluatefs",
    name: "detailEvaluatefs",
    component: detailEvaluatefs
  },
  {
    path: "/student/pickClass",
    name: "pickClass",
    component: pickClass
  },
  {
    path: "/student/creditStatistics",
    name: "creditStatistics",
    component: creditStatistics
  },
  {
    path: "/student/pickCenter",
    name: "pickCenter",
    component: pickCenter
  },
  {
    path: "/student/exitPick",
    name: "exitPick",
    component: exitPick
  },
  {
    path: "/student/pickDetail",
    name: "pickDetail",
    component: pickDetail
  },
  {
    path: "/student/pickRecord",
    name: "pickRecord",
    component: pickRecord
  },
  {
    path: "/student/timetable",
    name: "timetable",
    component: timetable,
    meta: {
      title: "学生课表"
    }
  },
  {
    path: "/student/textbook",
    name: "timetables",
    component: textbook
  },
  {
    path: "/student/supplementExam",
    name: "supplementExam",
    component: SupplementExam
  },

  {
    path: "/student/textbook_Details",
    name: "textbook_Details",
    component: textbook_Details
  },
  {
    path: "/student/attendance",
    name: "attendanceRate",
    component: attendanceRate,
    meta: {
      title: "课堂签到"
    }
  },
  {
    path: "/student/attendance_qzzyjsdx",
    name: "attendanceRate_qzzyjsdx",
    component: attendanceRate_qzzyjsdx,
    meta: {
      title: "课堂签到"
    }
  },
  {
    path: "/student/attendanceAdd",
    name: "studentAttendance",
    component: studentAttendance,
    meta: {
      title: ""
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/student/attendanceDetailAdd",
    name: "studentAttendanceDtl",
    component: studentAttendanceDtl,
    meta: {
      title: ""
    }
  },
  //辅修报名
  {
    path: "/student/minorSearch",
    name: "minorSearch",
    component: MinorSearch
  },
  {
    path: "/student/minorList/:route_params",
    name: "minorList",
    component: MinorList
  },
  //重修报名
  {
    path: "/student/retouchList",
    name: "retouchList",
    component: RetouchList
  },
  //重修报名_武汉科技大学个性化
  {
    path: "/student/retouchList_10488",
    name: "retouchList_10488",
    component: () =>
      import("@/components/student/retouchSignUp/10488/list.vue")
  },
  //重修报名选课
  {
    path: "/student/cxCuarChooseHistory",
    name: "cxCuarChooseHistory",
    component: cxCuarChooseHistory
  },
  {
    path: "/student/cxCuarChoose",
    name: "cxCuarChoose",
    component: cxCuarChoose
  },
  {
    path: "/student/cxCuarChooseList",
    name: "cxCuarChooseList",
    component: cxCuarChooseList
  },

  {
    path: "/student/retouchSubmit/:route_params",
    name: "retouchSubmit",
    component: RetouchSubmit
  },
  {
    path: "/student/retouchChooseCureList",
    name: "RetouchChooseCureList",
    component: RetouchChooseCureList
  },
  {
    path: "/student/RetouchCureDeal",
    name: "RetouchCureDeal",
    component: RetouchCureDeal
  },

  // 班级课表
  {
    path: "/student/class-timetable-search",
    name: "stuClassTimeTableSearch",
    component: () => import("@/components/student/class-timetable/search.vue")
  },
  {
    path: "/student/class-timetable-detail/:route_params",
    name: "stuClassTimeTableDetail",
    component: () =>
      import("@/components/student/class-timetable/timetable.vue")
  },
  // 毕业状态查询
  {
    path: "/student/SelectGraduationStatus-index",
    name: "graduationStatus",
    component: () =>
      import("@/components/student/SelectGraduationStatus/index.vue")
  },
  // 重修查询
  {
    path: "/student/searchRetest",
    name: "searchRetest",
    component: () => import("@/components/student/searchRetest.vue")
  }, // 学业进度
  {
    path: "/student/studyStatu",
    name: "studyStatu",
    component: () => import("@/components/student/studyStatu.vue")
  }, // 学业进度
  {
    path: "/student/studyStatu1",
    name: "studyStatu",
    component: () => import("@/components/student/studyStatu1/index.vue")
  }, // 学业进度
  {
    path: "/student/index1",
    name: "studyStatuIndex1",
    component: () => import("@/components/student/studyStatu1/index1.vue")
  }, // 学业进度详情
  {
    path: "/student/studyStatuItem",
    name: "studyStatuItem",
    component: () => import("@/components/student/studyStatu1/item.vue")
  }, // 补考报名
  {
    path: "/student/registRetest",
    name: "registRetest",
    component: () => import("@/components/student/reTest/registRetest.vue")
  },
  {
    path: "/student/myRetest",
    name: "myRetest",
    component: () => import("@/components/student/reTest/myRetest.vue")
  },
  {
    path: "/student/weixinPayMsg",
    name: "myRetest",
    component: () => import("@/components/student/reTest/weixinPayMsg.vue")
  },
  {
    path: "/student/gradeRules",
    name: "gradeRules",
    component: () => import("@/components/student/gradeRules/index.vue")
  },
  {
    path: "/student/xfwcqk_whkjdx/kcxdmx",
    name: "xs_xfwcqk_whkjdx",
    component: () => import("@/components/student/xfwcqk_whkjdx/kcxdmx.vue")
  },
  {
    path: "/student/byjlck_whkjdx",
    name: "xs_byjlck_whkjdx",
    component: () => import("@/components/student/byjlck_whkjdx/index.vue")
  },
  //报道注册
  {
    path: "/student/registraTion",
    name: "registraTion",
    component: RegistraTion
  },
  {
    path: "/student/xs_xjxxck",
    name: "xs_xjxxck",
    component: xs_xjxxck
  },
  {
    path: '/student/design',
    name: 'xs_design',
    component: xs_design
  },
  {
    path: '/student/to_guideRecode',
    name: 'to_guideRecode',
    component: to_guideRecode
  },
  {
    path: '/student/myGuideDeal_unload',
    name: 'myGuideDeal_unload',
    component: myGuideDeal_unload
  },
  {
    path: '/student/MyGuideDeal',
    name: 'MyguideDeal',
    component: MyguideDeal
  },
  {
    path: '/student/addQustMsg_unline',
    name: 'addQustMsg_unline',
    component: addQustMsg_unline
  },
  {
    path: '/student/addQustMsg',
    name: 'addQustMsg',
    component: addQustMsg
  },
  {
    path: "/student/zyjhDkxz",
    name: "zyjhDkxz",
    component: zyjhDkxz
  },
  {
    path: "/student/zyjhDk",
    name: "zyjhDk",
    component: zyjhDk
  },
  {
    path: "/student/xsxkjcDg",
    name: "xsxkjcDg",
    component: xsxkjcDg
  },
  {
    path: "/student/xsxkjcDg_jcxz",
    name: "xsxkjcDg_jcxz",
    component: xsxkjcDg_jcxz
  },
  {
    path: '/student/xs_ktpj',
    name: 'xs_ktpj',
    component: () => import('@/components/newPages/student/classroomAssessment/index.vue')
  },
  {
    path: '/student/xs_ktpj_list',
    name: 'xs_ktpj_list',
    component: () => import('@/components/newPages/student/classroomAssessment/assessmentList.vue')
  },
  {
    path: '/student/xs_assessment',
    name: 'xs_assessment',
    component: () => import('@/components/newPages/student/classroomAssessment/assessment.vue')
  },
  {
    path: '/pyfawcqk/index',
    name: 'pyfawcqkIndex',
    component: () => import('@/components/newPages/student/pyfawcqk/index.vue')
  },
  {
    path: '/pyfawcqk/detail',
    name: 'pyfawcqkDetail',
    component: () => import('@/components/newPages/student/pyfawcqk/detail.vue')
  },
  {
    path: '/student/reqbyby',
    name: 'xs_reqbyby',
    component: () => import('@/components/newPages/student/byxfyq/detail.vue')
  },
  {
    path: "/SyKbTable",
    name: "newTable",
    component: SyKbTable
  },
  {
    path: "/SyKbTable_whkj",
    name: "newTable_whkj",
    component: SyKbTable_whkj
  },
  {
    path: "/student/physicalExamination",
    name: "physicalExamination",
    component: physicalExamination
  },
  {
    path: "/student/physicalExamination_mx",
    name: "physicalExamination_mx",
    component: physicalExamination_mx
  },
  {
    path: "/student/physicalExamination_cfmx",
    name: "physicalExamination_cfmx",
    component: physicalExamination_cfmx
  },
  {
    path: '/student/bybz',
    name: 'xs_bybzIndex',
    component: () => import('@/components/student/bybz/index.vue')
  },
  {
    path: '/student/bybz_xf',
    name: 'xs_bybzxfDetail',
    component: () => import('@/components/student/bybz/xf_detail.vue')
  },
  {
    path: '/student/ksapcqdz',
    name: 'xs_Ksapcqdz',
    component: () => import('@/components/student/kaowu/index.vue')
  },
  {
    path: '/student/jzcjcx',
    name: 'xs_jzcjcx',
    component: () => import('@/components/student/kaowu/cjcx/index.vue')
  },
  {
    path: '/student/cxxfkcList',
    name: 'xs_cxsfkc',
    component: () => import('@/components/student/retouchSignUp/10488/cxsf_list.vue')
  },
  {
    path: '/student/syyygl',
    name: 'xs_Syyygl',
    component: () => import('@/components/student/syyygl/syyykc_list.vue')
  },
  {
    path: '/student/syyyxmXz',
    name: 'xs_syyyxmXz',
    component: () => import('@/components/student/syyygl/syyyxm_list.vue')
  },
  {
    path: "/student/xfjpmcx",
    name: "xs_xfjpmcx",
    component: () => import("@/components/student/cjxfjcx/index.vue")
  },
];
export default studentRoute;



// WEBPACK FOOTER //
// ./src/router/student.js